// 发布订阅模式
class EventEmitter {
  constructor() {
    // 事件对象，存放订阅的名字和事件 如：{'click': [handle, handle2]}
    this.events = {};
  }

  // 订阅事件方法
  on(eventName, callback) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(callback);
  }

  // 触发事件方法
  emit(eventName, ...rest) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(f => f.apply(this, rest))
    }
  }

  // 移除订阅事件
  un(eventName, callback) {
    if (this.events[eventName]) {
      this.events[eventName] = this.events[eventName].filter(f => f !== callback)
    }
  }

  // 只执行一次订阅的事件
  once(eventName, callback) {
    //创建临时方法
    const fn = (...rest) => {

      // 执行原有的callback
      callback.apply(this, rest)

      // 执行移除事件，删除临时方法
      this.un(eventName, fn)
    }

    // 执行订阅事件，绑定临时方法
    this.on(eventName, fn);
  }
}

export default EventEmitter;
